import { useEffect, useReducer, useState } from "react";
import { brandState, brandStateMange } from "./brandDataManage";
import { useNavigate, useLocation } from "react-router-dom";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
} from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import { useLoading } from "../../../context/LodingContext";
import MaterialBox from "../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../components/MaterialInput";
import ImageSelector from "../../components/ImageSelector";
import MaterialButton from "../../../components/MaterialButton";
import { useMutation } from "@apollo/client";
import { CREATE_Brand, Update_brand } from "./brandData";
import Swal from "sweetalert2";
import { useAuthData } from "../../context/loginContext/LoginContextProvider";
import FullscreenIcon from "@mui/icons-material/Fullscreen";

const BrandForm = () => {
  const [brandData, dispatch] = useReducer(brandStateMange, brandState);
  const [inputDisble, setInputDisble] = useState(false);
  const [createBrand] = useMutation(CREATE_Brand);
  const [UpdateBrand] = useMutation(Update_brand);
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const { userId } = useAuthData();

  const formType = location?.state?.type;

  const formValue = location?.state?.data;

  useEffect(() => {
    if (formValue) {
      dispatch({
        value: formValue?.brandName,
        name: "brandName",
      });

      dispatch({
        value: formValue?.brandCode,
        name: "brandCode",
      });
      dispatch({
        value: formValue?.brandDescription,
        name: "brandDescription",
      });
      dispatch({
        value: formValue?.brandLogo,
        name: "brandLogo",
      });
    }
  }, [formValue]);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  const checkAllFields = () => {
    let allowSubmit = false;
    if (
      brandData.brandNameStatus === "success" &&
      brandData.brandCodeStatus === "success"
    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handleImageSelect = (file) => {
    dispatch({ value: file, name: "brandLogo" });
  };

  const handleAddBrand = async () => {
    setCirleLoading(true);

    try {
      const response = await createBrand({
        variables: {
          input: {
            user: userId,
            brandCode: brandData.brandCode,
            brandName: brandData.brandName,
            brandDescription: brandData.brandDescription,
            brandLogo: brandData.brandLogo,
          },
        },
        context: { hasUpload: true },
      });

      const success = response?.data?.createBrand?.success;

      const message = response?.data?.createBrand?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/brand");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdateBrand = async () => {
    setCirleLoading(true);

    try {
      const response = await UpdateBrand({
        variables: {
          input: {
            id: formValue?.id,
            brandName: brandData.brandName,
            brandCode: brandData.brandCode,
            brandDescription: brandData.brandDescription,
            brandLogo: brandData.brandLogo?.name ? brandData.brandLogo : null,
          },
        },
        context: { hasUpload: true },
      });
      const success = response?.data?.updateBrand?.success;
      const message = response?.data?.updateBrand?.message;

      if (success) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: message,
          showConfirmButton: true,
        }).then(() => {
          navigate("/brand");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setCirleLoading(false);
    }
  };

  const handleDownload = async () => {
    const imageUrl = formValue?.brandLogo;
    if (!imageUrl) return;

    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "brand_image.jpg";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <DashboardLayout>
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="md"
      >
        <DialogContent>
          {ImageSelector ? (
            <img
              src={formValue?.brandLogo}
              alt="Brand"
              style={{
                maxWidth: "100%",
                maxHeight: "80vh",
                borderRadius: "8px",
                objectFit: "contain",
                display: "block",
              }}
            />
          ) : (
            <MaterialTypography>No image available</MaterialTypography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Close</Button>
          {formType == "view" ? (
            <Button onClick={handleDownload}>Download</Button>
          ) : (
            ""
          )}
        </DialogActions>
      </Dialog>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Brand Details"
                    : formType == "edit"
                    ? "Edit Brand Details"
                    : "View Brand Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Brand Code <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={brandData?.brandCode}
                  name="brandCode"
                  placeholder="Enter Brand Code"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "brandCode" })
                  }
                  error={brandData.brandCodeStatus === "error" ? true : false}
                  success={
                    brandData.brandCodeStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Brand Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={brandData?.brandName}
                  name="brandName"
                  placeholder="Enter Brand Name"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "brandName" })
                  }
                  error={brandData.brandNameStatus === "error" ? true : false}
                  success={
                    brandData.brandNameStatus === "success" ? true : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Brand Description
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  multiline
                  rows={5}
                  value={brandData?.brandDescription}
                  placeholder="Enter Brand Description"
                  name="brandDescription"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "brandDescription",
                    })
                  }
                  error={
                    brandData.brandDescriptionStatus === "error" ? true : false
                  }
                  success={
                    brandData.brandDescriptionStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Brand Image
                  </MaterialTypography>
                </MaterialBox>

                <FullscreenIcon
                  fontSize="small"
                  className="viewIcon"
                  onClick={() => {
                    setDialogOpen(true);
                  }}
                  style={{
                    cursor: "pointer",
                    marginLeft: "8px",
                    verticalAlign: "middle",
                  }}
                />
                <ImageSelector
                  onImageSelect={handleImageSelect}
                  imageUrl={formValue?.brandLogo}
                  disabled={inputDisble}
                />
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate("/brand")}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={formType == "add" ? handleAddBrand : handleUpdateBrand}
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default BrandForm;
